import VanshavaliPdfCard from "../components/Vanshavali/PdfCard";
import { framilyTreeData } from "../data";

function Vanshavali() {
  return (
    <div className="container py-3 py-lg-5">
      <h1 className="h3">Vanshavali</h1>
      <div className="row">
        {framilyTreeData.map((item, i) => {
          const base = item.pdf?.toLowerCase().endsWith(".pdf")
            ? item.pdf.slice(0, -4)
            : item.pdf;
          const title = base
            ? base.charAt(0).toUpperCase() + base.slice(1)
            : "PDF";
          return (
            <div className="col-6 col-sm-4 col-lg-3" key={i}>
              <VanshavaliPdfCard title={title} pdf={item.pdf} />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Vanshavali;
